import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseUrl = `${baseURL}/orders/`;

export const orderApiService = createApi({
    reducerPath: 'orderApi',
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const { token } = getState().authSlice; // Destructuring 'token' from authSlice state

            headers.set('Authorization', `Bearer ${token}`); // Setting the Authorization header
            return headers;
        },
    }),
    endpoints: (builder) => ({
        createOrder: builder.mutation({
            query: (body) => {
                return {
                    url: `${baseURL}/orders`,
                    method: 'POST',
                    body,
                };
            },
        }),
        getSingleOrder: builder.query({
            query: ({ page = 1, limit = 10 } = {}) => {
                return `my-orders?page=${Number(page) || 1}&limit=${Number(limit) || 10}`; // Ownership comes from the verified session.
            },
            keepUnusedDataFor: 0, // Do not cache the data
            refetchOnMountOrArgChange: true, // Refetch data on mount or when arguments change
        }),


        returnOrder: builder.mutation({
            query: (body) => {

                return {
                    url: 'return', // Ensure this matches your API endpoint
                    method: 'POST',
                    body,
                };
            },
        }),
        getReturnedProducts: builder.query({
            query: ({ user_id }) => {
                if (user_id) {
                    return `getReturnedProducts?user_id=${user_id}`; // Ensure the endpoint matches your API
                }
                return ''; // Handle cases where user_id is not provided
            },
            refetchOnMountOrArgChange: true,  // Refetch every time the component mounts
            keepUnusedDataFor: 0,  // Remove data immediately when there are no subscribers
        }),
        
        checkUserOrders: builder.mutation({
            query: (body) => {

                return {
                    url: 'checkUserOrders', // Ensure this matches your API endpoint
                    method: 'POST',
                    body,
                };
            },
        }),
        getTracking: builder.query({
            query: (orderId) => {
                if (orderId) {
                    return `get-tracking/${orderId}`; // Use userId as a query parameter
                }
                return ''; // Return an empty string or handle cases where userId is not provided
            },
        }),
        
        calculateOrderSummary: builder.mutation({
            query: (body) => {
                return {
                    url: `${baseURL}/orders/calculate-summary`,
                    method: 'POST',
                    body,
                };
            },
        }),

    }),
});

export const {
    useCreateOrderMutation,
    useGetSingleOrderQuery,
    useReturnOrderMutation,
    useGetReturnedProductsQuery,
    useCheckUserOrdersMutation,
    useGetTrackingQuery,
    useCalculateOrderSummaryMutation,
} = orderApiService;
